import HeaderSection from "../../../components/Header/HeaderSection"


export default function MeetingText() {

    
    return (

        <HeaderSection

            headline_p1 = "Meet your" 
            headline_grey = "doctor"
            headline_p2 = "here"

            text1 = "This section is built to make videoconferences with experts and doctors - as scheduled before."
            text2 = "Usually an online counseling session takes one hour. If required you can book more sessions anytime."

        />

            
    )
}